import React,{useEffect,useState,useContext} from 'react';
import {MyContext} from '../../login/MyContext';
//import {Link} from 'react-router-dom';
import axios from 'axios';

const Count = () => {
  
  
  const {user, logout} = useContext(MyContext);
 

  const [hoy, setData]=useState([]);
    

    const peticionGet =async() =>{
      await axios.get(`https://manager-ads.com/ApiAliraweb.com/empresas/count_empresas.php?id=${global.id}`)
      .then(res=>{
       setData(res.data);
      
      }).catch(error=>{
        console.log(error);
      })
  
    }

   
    const [ayer, setData_suspendido]=useState([]);

    const peticionGet_licencias =async() =>{
        await axios.get(`https://manager-ads.com/ApiAliraweb.com/empresas/count_licencias_empresas.php?id=${global.id}`)
        .then(res=>{
         setData_suspendido(res.data);
        }).catch(error=>{
          console.log(error);
        })
    
      }


    
    const [mes, setData_nombre]=useState([]);

    const peticionGet_solicitudes =async() =>{
        await axios.get(`https://manager-ads.com/ApiAliraweb.com/empresas/count_solicitudes_empresas.php?id=${global.id}`)
        .then(res=>{
          setData_nombre(res.data);
        }).catch(error=>{
          console.log(error);
        })
    
      }



    const [saldo, setData_s]=useState([]);

    const peticionGet_e_suspendidas =async() =>{
        await axios.get(`https://manager-ads.com/ApiAliraweb.com/empresas/count_empresas_suspendias.php?id=${global.id}`)
        .then(res=>{
         setData_s(res.data);
        }).catch(error=>{
          console.log(error);
        })
    
      }


     

      
      

    

 useEffect(()=>{
    

      const interval = setInterval(() => {
        
       peticionGet();
        peticionGet_e_suspendidas();
        peticionGet_licencias();
        peticionGet_solicitudes();
         
       }, 1000);
    
     return () => setInterval(interval);
    
     },[])

  return (
    <div class="row">


<div class="col-xl-3 col-md-6">
<div class="widget widget-stats " style={{background:'#1565c0'}} >
  
<div class="stats-icon"> </div>
<div class="stats-info">
<h4>Hoy hasta este momento</h4>
<br/>
<h1>USD ${hoy}</h1>

<h4>Ingresos estimados</h4>
</div>

</div>
</div>

<div class="col-xl-3 col-md-6">
<div class="widget widget-stats "  style={{background:'#1565c0'}}>
<div class="stats-icon"></div>
<div class="stats-info">
<h4>Ayer</h4>
<br/>
<h1>USD ${ayer}</h1>
<h4>en comparación con el mismo día</h4>
</div>

</div>
</div>


<div class="col-xl-3 col-md-6">
<div class="widget widget-stats "  style={{background:'#1565c0'}}>
<div class="stats-icon"></div>
<div class="stats-info">
<h4>Este mes</h4>
<br/>
<h1>USD ${mes}</h1>
<h4>en comparación con el mismo período</h4>
</div>

</div>
</div>


<div class="col-xl-3 col-md-6">
<div class="widget widget-stats "  style={{background:'#1565c0'}}>
<div class="stats-icon"><img src="../assets/img/google/google.gif" width="40px" 
style={{opacity: 0.6}} /></div>
<div class="stats-info">
<h4>Saldo</h4>
<br/>
<h1>USD ${saldo}</h1>
<h4>saldos pendientes </h4>
</div>

</div>
</div>



</div>



  )
}

export default Count